import {required, requiredIf} from 'vuelidate/lib/validators';
import { timerCheckpoint } from "@modules/JourneyBuilder/Bricks/Checkpoints";

const timeRequiredValidator = timeObj => {
    return required(timeObj.hour) &&
        required(timeObj.minute) &&
        required(timeObj.second);
}

const conditionValidations = {
    field: {
        required
    },
    value: {
        required
    }
};

const conditionGroupValidations = {
    $each: {
        children: {
            required, //Require at least a single condition
            $each: conditionValidations
        }
    }
};

const timerScheduleOnceValidations = {
    date: {
        required: required
    },
    time: {
        required: timeRequiredValidator
    }
}

const timerFrequencyValidations = {
    unit: {
        required
    },
    recursInDays: {
        required
    }
};

//We require a locator function due to the validator set being reused in multiple components with a differing structure
const buildTimerDailyFrequencyValidatorSet = (getValidatedRootObject) => {
    const DAILY_FREQUENCIES = timerCheckpoint.DAILY_FREQUENCIES;
    
    return {
        frequency: {
            required
        },
        recursInSeconds: {
            required: requiredIf(function() { return getValidatedRootObject(this).frequency === DAILY_FREQUENCIES.MULTIPLE_TIMES.id; })
        },
        startTime: {
            required: timeRequiredValidator
        },
        endTime: {
            isOnOrAfterStartTime() {
                const rootObject = getValidatedRootObject(this);

                //Only validate when endTime is actually required
                if(rootObject.frequency !== DAILY_FREQUENCIES.MULTIPLE_TIMES.id) {
                    return true;
                }

                const startTime = rootObject.startTime;
                const endTime = rootObject.endTime;

                //Protect against comparison against undefined
                const endHour = endTime.hour || 0;
                const endMinute = endTime.minute || 0;
                const endSecond = endTime.second || 0;
                const startHour = startTime.hour || 0;
                const startMinute = startTime.minute || 0;
                const startSecond = startTime.second || 0;
                
                if(endHour === startHour) {
                    if(endMinute === startMinute) {
                        return endSecond >= startSecond;
                    }

                    return endMinute >= startMinute;
                }
                
                return endHour >= startHour;
            },

            required() {
                const rootObject = getValidatedRootObject(this);

                //Only validate when endTime is actually required
                if(rootObject.frequency !== DAILY_FREQUENCIES.MULTIPLE_TIMES.id) {
                    return true;
                }

                return timeRequiredValidator.apply(this, arguments);
            }
        }
    };
};

const timerDurationValidations = {
    startDate: {
        required
    },
    endDate: {
        required: requiredIf(model => !model.isPerpetual)
    }
};

export {
    conditionValidations,
    conditionGroupValidations,

    timerScheduleOnceValidations,
    timerFrequencyValidations,
    buildTimerDailyFrequencyValidatorSet,
    timerDurationValidations
}